// src/services/configService.ts
interface Config {
  name: string;
  apiEndpoint: string;
  /** Legacy implicit-flow login URL — rollback path while `auth_flow` rolls out. */
  redirect_url: string;
  main_page: string;
  /** Cognito hosted-UI custom domain (authorize + token endpoints live here). */
  auth_domain: string;
  client_id: string;
  /** Byte-identical in authorize + token calls; hardcoded, never
   *  window.location.origin (westernava.com is not a registered callback). */
  oauth_redirect_uri: string;
  /** Cognito user-pool issuer — must equal the id_token `iss` claim. */
  oidc_issuer: string;
  /** 'code' = authorization-code+PKCE with silent refresh; 'implicit' = legacy. */
  auth_flow: "code" | "implicit";
  [key: string]: string;
}

const prodConfig: Config = {
  name: "prod",
  apiEndpoint: "https://api.prod.westernbulk.cloud/v1",
  redirect_url: "https://auth.prod.westernbulk.cloud/oauth2/authorize?identity_provider=LOGIN&response_type=token&client_id=52q24rpchcoct0fkv2cktqi4ie&redirect_uri=https://react.prod.westernbulk.cloud&scope=aws.cognito.signin.user.admin%20email%20openid",
  main_page: "https://react.prod.westernbulk.cloud/",
  auth_domain: "https://auth.prod.westernbulk.cloud",
  client_id: "52q24rpchcoct0fkv2cktqi4ie",
  oauth_redirect_uri: "https://react.prod.westernbulk.cloud",
  oidc_issuer: "https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_stDWbKD1s",
  auth_flow: "code",
  // Add other prod-specific settings here
};

const testConfig: Config = {
  name: "test",
  apiEndpoint: "https://api.sandbox.westernbulk.cloud/v1",
  redirect_url: "https://auth.sandbox.westernbulk.cloud/oauth2/authorize?identity_provider=LOGIN&response_type=token&client_id=13b613ntlkph5s8mncslosvlot&redirect_uri=https://react.sandbox.westernbulk.cloud&scope=aws.cognito.signin.user.admin%20email%20openid",
  main_page: "https://react.sandbox.westernbulk.cloud/",
  auth_domain: "https://auth.sandbox.westernbulk.cloud",
  client_id: "13b613ntlkph5s8mncslosvlot",
  oauth_redirect_uri: "https://react.sandbox.westernbulk.cloud",
  oidc_issuer: "https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_KzFECJaVv",
  auth_flow: "code",
  // Add other test-specific settings here
};

const localConfig: Config = {
  name: "local",
  apiEndpoint: "https://api.sandbox.westernbulk.cloud/v1",
  redirect_url: "https://auth.sandbox.westernbulk.cloud/oauth2/authorize?identity_provider=LOGIN&response_type=token&client_id=13b613ntlkph5s8mncslosvlot&redirect_uri=https://react.sandbox.westernbulk.cloud&scope=aws.cognito.signin.user.admin%20email%20openid",
  main_page: "https://react.sandbox.westernbulk.cloud/",
  auth_domain: "https://auth.sandbox.westernbulk.cloud",
  client_id: "13b613ntlkph5s8mncslosvlot",
  oauth_redirect_uri: "https://react.sandbox.westernbulk.cloud",
  oidc_issuer: "https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_KzFECJaVv",
  auth_flow: "code", // moot on localhost (TOKEN constant short-circuits auth)
  // Add other local-specific settings here
};

const getEnvironmentConfig = (): Config => {
  const hostname = window.location.hostname;

  if (hostname.includes("localhost")) {
    return localConfig;
  }
  else if (hostname.includes("prod") || hostname.includes("westernava.com")) {
    return prodConfig;
  } else if (hostname.includes("sandbox")) {
    return testConfig;
  } else {
    return testConfig;
  }
};

export const getConfig = getEnvironmentConfig;
